<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('name')"
                    outlined
                    dense
                    v-model="form.name"
                    hide-details="auto"
                    :rules=[isRequired]>
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from '../../utils/validations';

export default {
    data() {
        return{
            form: {
                name: ""
            }
        }
    },
    props: {
        value: Object
    },
    methods: {
        isRequired,
        validate() {
            return this.$refs.form.validate();
        }
    },
    watch:{
        form: {
            handler() {
                this.$emit("input", this.form);
            },
            deep: true
        }
    },
    created() {
        this.form = {... this.value}
    }
}
</script>

<style>

</style>